import React from 'react'
import {FiPlus, FiUser, FiHeart, FiSettings, FiLock, FiEdit, FiMap, FiPhone, FiMapPin, FiBriefcase, 
    FiMail, FiClock, FiStar, FiAlertTriangle, FiXOctagon, FiHome, FiBell, FiFile, FiCreditCard
} from 'react-icons/fi'
import {ImFire} from 'react-icons/im'



export const smallGallery = [
    {img:'office'},
    {img:'code'},
    {img:'twitter'},
    {img:'car'},
    {img:'camera'},
]


export const requests = [
    { title: 'The Designer', desc: 'C++ developer at Microsoft', img: '/assets/images/faces/1.png' },
    { title: 'The Author', desc: 'Freelance Graphics & UI Designer', img: '/assets/images/faces/2.png' },
    { title: 'The Developer', desc: 'Designer & Illustrator', img: '/assets/images/faces/3.png' },
    { title: 'The Writer', desc: 'Designer', img: '/assets/images/faces/4.png' },
]

export const opts = [
    {symbol:<FiUser />,title:'Profiles', url:'/account'},
    {symbol:<FiHeart />,title:'Favorites', url:'/account/favorites'},
    {symbol:<FiSettings />,title:'Settings', url:'/account/setting'},
    {symbol:<FiLock />,title:'Change password', url:'/account/change'},
  
    // {symbol:<FiBriefcase />,title:'My Projects', url:'#/account/myprojects', sharp:true},
    // {symbol:<FiUsers />,title:'My Profiles', url:'#/account/profiles', sharp:true},
    // {symbol:<FiBarChart />,title:'Statistics', url:'#',  sharp:true},
    // {symbol:<FiSend />,title:'Chat', url:'#',  sharp:true},
    // {symbol:<FiCreditCard />,title:'Payment', url:'#', sharp:true},
    // {symbol:<FiMapPin />,title:'Location', url:'#',  sharp:true},
    // {symbol:<FiUsers />,title:'Team', url:'#',  sharp:true},
   
    // {symbol:<FiSlash />,title:'Blocked', url:'#/account/blocks', sharp:true},
   
    // {symbol:<FiArchive />,title:'Inbound', url:'/account/requests'},
    // {symbol:<FiInbox />,title:'Outbound', url:'#'},
  
    // {symbol:<FiMoon />,title:'Darkmode', url:'#',  sharp:true},
    // {symbol:<FiHelpCircle />,title:'Help & Support', url:'#',  sharp:true},
];


export const aboutlist = [
    { letter: 'TA', title:'Java Developer', description:'Oracle Inc'},
    {symbol: <FiMap />, title:'Particle Physics', description:'Cairo, Egypt'},
    {symbol: <FiPhone />, title:'345 678 91 23'},
    {symbol: <FiUser />, title:'test@test.com'},
    {symbol: <FiMapPin />, title:'Living in Paris'},
    {img: <img src="/assets/images/faces/1.png" alt="avatar" />, title:'Arabic, English knows'},
    {symbol: <FiPlus />, description:'Add School', add:true},
  
]
 
 
export const personals = [
    {symbol: <FiBriefcase />, title:'Microsoft', description:'Kernel Engineer'},
    {symbol: <FiPhone />, title:'0512 345 67 89', description:'Business Phone'},
    {symbol: <FiMail />, title:'text@example.com', description:'Business email'},
    {symbol: <FiClock />, title:'10:00-17:00', description:'Suitable'},
    {symbol: <FiPlus />, title:'Add an address', add:true},
    {symbol: <FiPlus />, title:'Add social profiel', add:true},
]
 


export const fieldList = [
    {title:'Education', description:'Enter Educational information.'},
    {title:'Experiments', description:'Job Experiments'},
    {title:'Courses', description:'Add or edit Courses'},
    {title:'Languages', description:'Give a point to language'},
    {title:'Skills', description:'Add or edit Skill'},
    {title:'Socials', description:'Add or edit Social'},
]

export const personList = [
    {name:'Hasan Azam', avatar:'/assets/images/faces/1.png', place:'Cairo, Egypt', followed:true},
    {name:'Omar Azam', avatar:'/assets/images/faces/3.png', place:'Cairo, Egypt', followed:false},
    {name:'Jake Patrice', avatar:'/assets/images/faces/4.png', place:'Washington, US.', followed:false},
    {name:'Jane Patrice', avatar:'/assets/images/faces/2.png', place:'Paris, France.', followed:true},
];


export const friendList = [
    {name:'Francisco Gibss', avatar:1, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:2, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:3, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:4, description:'130 mutual friends'},
    {name:'Francisco Gibss', description:'130 mutual friends'},
    {name:'Francisco Gibss', description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:10, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:11, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:12, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:13, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:14, description:'130 mutual friends'},
    {name:'Francisco Gibss', avatar:15, description:'130 mutual friends'},
]


export const projectsList = [
    {title:'We will create an nft art collection with 100, 1k, 10k nfts for opeansea', images:[1,2,3,4,5]},
    {title:'I will create a wordpress website for your business', images:[3,4,5]},
]


export const projectSettingList = [
    {title:'Edit', symbol:<FiEdit />, url:'#'},
    {title:'Complain', symbol:<FiAlertTriangle /> , url:'#'},
    {title:'Remove', symbol:<FiXOctagon />, url:'#'},
]
 
export const experiments = [
    {id:1, position:'Kernel Engineer', city:'Marseille', start:'2023-07-11T09:20:20.726Z', end:'2025-07-01T09:20:20.726Z', working:1, company:'Cisco Inc', description:'lorem ipsum is simply dummy test of the printing and industry. Lorem  has been the industry’s standard dummy text'},
    {id:2, position:'Backend Developer', city:'Newyork', start:'2017-12-12T09:20:20.726Z',end:null, working:1, company:'Grammerly', description:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est maxime doloremque inventore rerum omnis deserunt saepe ullam architecto? Voluptates beatae, sapiente ut dignissimos architecto asperiores tenetur assumenda quam necessitatibus vel.'},
    {id:3, position:'FullStack Engineer', city:'Cairo', start:'2017-12-12T09:20:20.726Z',end:null, working:1, company:'Google Inc.', description:'Lorem ipsum is simply dummy test of the printing and industry. Lorem  has been the industry’s standard dummy text'}
];


export const jobList = [
    {id:1, position:'Art Director', city:'Cairo', start:'2019-06-11T09:20:20.726Z', end:'2022-07-01T09:20:20.726Z', working:1, company:'Agency', description:'lorem ipsum is simply dummy test of the printing and industry. Lorem  has been the industry’s standard dummy text'},
    {id:2, position:'Technical Responsible', city:'KNewyork', start:'2021-12-12T09:20:20.726Z',end:null, working:1, company:'TeamSQL', description:'Lorem ipsum is simply dummy test of the printing and industry. Lorem  has been the industry’s standard dummy text'}
  ];


  
export const aboutFeatureList = [
    //{title:'+90 5123 456 78', description:'Business', symbol:<FiPhone />, edit:false},
    {title:'Fullstack Developer at Google', description:'Previously Engineer at Zer0day', symbol:<FiPhone />, edit:false},
    {title:'example@example.com', description:'Business inquiries only', symbol:<FiMail />, edit:false},
    {title:'Usually available 9am-5pm', description:'Call +1 (930) 242-5186 for take an offer', symbol:<FiClock />, edit:false},
    {title:'Add an adress', symbol:<FiPlus />, edit:true},
    {title:'Add social profile', symbol:<ImFire />},
]


 
export  const brdcrmbs = [
    {symbol: <FiHome />, title:'Account', url:'/account'},
    {symbol: <FiBell />, title:'Notifications', url:'/notifications'},
    {symbol: <FiBriefcase />, title:'Projects', url:'/account/myprojects'},
    {symbol: <FiStar />, title:'Favorites', url:'/account/favorites'},
   {symbol: <FiFile />, title:'Ad Management', url:'#/advertisement', sharp:true},
   {symbol: <FiCreditCard />, title:'Payment', url:'#/account/payment', sharp:true}
] 



